import React, { useState, useEffect } from "react";
import "./App.css";
import "./Components/Common_Component/Form_Css/Form_Css.css";
import "./index.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import AboutUs from "./Components/AboutUs/AboutUs";
import ContactUs from "./Components/ContactUs/ContactUs";
import Service from "./Components/Service/Service";
import Career from "./Components/Career/Career";
import TermsCondition from "./Components/TermsCondition/TermsCondition";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import ScrollToTop from "./Components/ScrollTotop/ScrollTotop";
import Blog from "./Components/Blog/Blog";
import LeaderShip from "./Components/LeaderShip/LeaderShip";
import Loader from "./Components/Common_Component/Loader/Loader";
import Video_Wala_Bus_Stand_inner_content from "./Components/Service/All_services_inner/Video_Wala_Bus_Stand/Video_Wala_Bus_Stand_inner_content/Video_Wala_Bus_Stand_inner_content";
import All_services_inner from "./Components/Service/All_services_inner/All_services_inner";
import Multimedia_Services_inner from "./Components/Service/Multimedia_Services_inner/Multimedia_Services_inner";
import Digital_Media_Services_Inner from "./Components/Service/Digital_Media_Services_Inner/Digital_Media_Services_Inner";
import Print_Media_inner from "./Components/Service/Print_Media_inner/Print_Media_inner";

import Lottie_Holder from "./Components/Lottie_Holder/Lottie_Holder";
import Branding_Inner_Service from "./Components/Service/Branding_Inner_Service/Branding_Inner_Service";
import Vdo_wala_vdo_holder from "./Components/Common_Component/Vdo_wala_vdo_holder/Vdo_wala_vdo_holder";

function App() {
  const [showVideo, setShowVideo] = useState(false); // State to toggle the video holder
  const location = useLocation(); // Get the current location

  useEffect(() => {
    if (location.pathname === "/services-inner/1") {
      setShowVideo(true); // Show the video for 3 seconds
      const timer = setTimeout(() => {
        setShowVideo(false); // Hide the video after 3 seconds
      }, 10000);
      return () => clearTimeout(timer); // Cleanup timer
    } else {
      setShowVideo(false); // Ensure the video is hidden for other routes
    }
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      <>
        {!showVideo && <Header />} {/* Hide Header if the video is showing */}
        {showVideo ? (
          <Vdo_wala_vdo_holder /> // Show the video holder for 3 seconds
        ) : (
          <>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/services" element={<Service />} />
              <Route path="/services-inner/:id" element={<All_services_inner />} />
              <Route
                path="/multimedia-services/:id"
                element={<Multimedia_Services_inner />}
              />
              <Route
                path="/digitalmedia-services/:id"
                element={<Digital_Media_Services_Inner />}
              />
              <Route
                path="/branding-services/:id"
                element={<Branding_Inner_Service />}
              />
              <Route
                path="/print-Media-services/:id"
                element={<Print_Media_inner />}
              />
              <Route path="/blog" element={<Blog />} />
              <Route path="/career" element={<Career />} />
              <Route path="/leaderShip" element={<LeaderShip />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-condition" element={<TermsCondition />} />
              <Route
                path="/video-wala-bus-stand"
                element={<Video_Wala_Bus_Stand_inner_content />}
              />
            </Routes>
            <Footer />
          </>
        )}
      </>
    </>
  );
}

export default App;
